// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
export var IPermissions;
(function (IPermissions) {
    IPermissions["GOLD_PERMISSION"] = "gold";
    IPermissions["SILVER_PERMISSION"] = "silver";
})(IPermissions || (IPermissions = {}));
